import _ from 'lodash'

import { actions, types } from '../actions/settings'
import { defaultLanguage, getLanguages, setLanguage } from '../../helpers/languages'

// When the therapist selects a different language, the translator switches to the appropriate dictionary.
const translator = (store) => {
    return (next) => {
        return (action) => {
            next(action)
            switch (action.type) {
                case types.SET_LANGUAGE:
                    // If the language is not among the supported ones, fall back to the default.
                    if (_.indexOf(getLanguages(), action.payload) === -1) {
                        store.dispatch(actions.setLanguage(defaultLanguage))
                    } else {
                        setLanguage(action.payload)
                    }
                    break
                default:
            }
        }
    }
}

export default translator



// WEBPACK FOOTER //
// ./src/store/middlewares/translator.js